import {useContext} from 'react'

import Context from '@s-ui/react-context'
import IconStarFilled from '@adv-mt/mt-svg-icons/lib/StarFilled.js'
import {Icon, ICON_SIZES} from '@adv-mt/ui/icon'
import {Link, LINK_SIZES} from '@adv-mt/ui/link'
import {Body1, Headline1} from '@adv-mt/ui/typography'

import {useContactCardInput, useContactSellerV2Config} from '../context/ContactSellerV2Context.js'
import {isPrivateSellerContract} from '../helpers/sellerType.js'
import SellerAvatar from './SellerAvatar.js'
import SellerPackBadge from './SellerPackBadge.js'

export const BASE_CLASS = 'mt-SellerInfo'

export const SELLER_HEADING_ID = 'mt-SellerInfo-heading'

const SellerInfo = () => {
  const {domain, i18n} = useContext(Context)
  const {contractId} = useContactSellerV2Config()
  const {sellerName, sellerLogo, sellerPhoto, location, ratingAverage, ratingCount, onShowAllRatings, pack} =
    useContactCardInput()

  if (!sellerName) {
    return null
  }

  const {AD_DETAIL_PAGE_SECTION_IDS} = domain.get('config').get('COMMON').AD_DETAIL_PAGE_SECTIONS
  const {PRIVATE_CONTRACT_ID} = domain.get('config').get('dealer')
  const sellerSectionId = AD_DETAIL_PAGE_SECTION_IDS.SELLER

  const handleShowAllRatings = event => {
    event.preventDefault()
    onShowAllRatings?.()
  }

  const isProfessional = !isPrivateSellerContract({
    contractId,
    privateContractId: PRIVATE_CONTRACT_ID,
    whenMissingContractId: true
  })

  return (
    <div className={BASE_CLASS}>
      <Headline1 as="p" className={`${BASE_CLASS}-heading`} id={SELLER_HEADING_ID}>
        {i18n.t('CONTACT_SELLER_V2.FORM.TITLE')}
      </Headline1>

      <div className={`${BASE_CLASS}-profile`}>
        <SellerAvatar
          isProfessional={isProfessional}
          sellerLogo={sellerLogo}
          sellerName={sellerName}
          sellerPhoto={sellerPhoto}
        />
        <div className={`${BASE_CLASS}-text`}>
          <div className={`${BASE_CLASS}-name`}>
            <Body1 as="span" className={`${BASE_CLASS}-nameValue`} highlight>
              {sellerName}
            </Body1>
            <SellerPackBadge pack={pack} />
          </div>
          {(ratingAverage != null || location) && (
            <div className={`${BASE_CLASS}-meta`}>
              {ratingAverage != null && (
                <span className={`${BASE_CLASS}-rating`}>
                  <Body1 as="span" highlight>
                    {i18n.t('CONTACT_SELLER_V2.SELLER_INFO.RATING', {average: ratingAverage})}
                  </Body1>
                  <Icon size={ICON_SIZES.SM}>
                    <IconStarFilled size={ICON_SIZES.SM} />
                  </Icon>
                  {ratingCount != null && (
                    <Body1 as="span">
                      (
                      <Link
                        className={`${BASE_CLASS}-ratingCount`}
                        href={`#${sellerSectionId}`}
                        onClick={handleShowAllRatings}
                        size={LINK_SIZES.BODY_1}
                      >
                        {ratingCount}
                      </Link>
                      )
                    </Body1>
                  )}
                </span>
              )}
              {ratingAverage != null && location && (
                <Body1 aria-hidden="true" as="span">
                  ·
                </Body1>
              )}
              {location && (
                <Body1 as="span" className={`${BASE_CLASS}-location`}>
                  {location}
                </Body1>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

SellerInfo.displayName = 'SellerInfo'

SellerInfo.propTypes = {}

export default SellerInfo
